import '../styles.scss'
import React from 'react'

import { Selector } from 'components/SmartChatView/Fields'

const CourtesyMessagesViewUI = ({ renderType, label, placeholder, courtesyMessagesOptions, helloPetitionsOptions, byePetitionsOptions, thanksPetitionsOptions, value, onChangeInner, error, previewIntegrity }) => (
  <div className='action-view'>
    {renderType === 'action' && (
      <>
        <Selector
          isRequired
          label={label.message}
          placeholder={placeholder.message}
          options={courtesyMessagesOptions}
          value={value.message}
          onChange={value => onChangeInner({ fieldType: 'message', fieldData: value })}
          error={error?.message}
        />
        {value.message?.value && (
          <Selector
            isRequired
            label={label.petition}
            placeholder={placeholder.petition}
            options={value.message.value === 'HELLO'
              ? helloPetitionsOptions
              : value.message.value === 'BYE'
                ? byePetitionsOptions
                : value.message.value === 'THANKS'
                  ? thanksPetitionsOptions
                  : []
            }
            value={value.petition}
            onChange={value => onChangeInner({ fieldType: 'petition', fieldData: value })}
            error={error?.petition}
          />
        )}
      </>
    )}
    {renderType === 'preview' && (
      <div className='action-view__courtesy-messages-preview'>
        <Selector
          placeholder={placeholder.message}
          options={courtesyMessagesOptions}
          value={value.message}
          onChange={value => onChangeInner({ fieldType: 'message', fieldData: value })}
          error={previewIntegrity.message}
        />
        <Selector
          placeholder={placeholder.petition}
          options={value.message?.value === 'HELLO'
            ? helloPetitionsOptions
            : value.message?.value === 'BYE'
              ? byePetitionsOptions
              : value.message?.value === 'THANKS'
                ? thanksPetitionsOptions
                : []
          }
          value={value.petition}
          onChange={value => onChangeInner({ fieldType: 'petition', fieldData: value })}
          error={previewIntegrity.petition}
        />
      </div>
    )}
  </div>
)

export default CourtesyMessagesViewUI
